import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainSettingsQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainSettingsQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', id: number, name: string, description: string, companyName?: string | null, preferDisplayNamesForStationNames: boolean, shortNumbersLength: number, specialNumbersDialoutPrefix?: string | null, smtpAuthEnabled?: boolean | null, smtpUsername?: string | null, smtpUserpass?: string | null, pinBasedCalls?: boolean | null, privateRoutingType: Types.PrivateRoutingType, dialoutPrefix?: string | null, attendantPrefix?: string | null, requirePinForStartingPrivateCalls: boolean, groupDomain?: string | null, faxSignature?: string | null, baseColor?: string | null, loginBackgroundColor?: string | null, backgroundIsCenter?: boolean | null, backgroundColor?: string | null, outgoingCallBarringOperator?: any | null, outgoingCallBarringAdmin?: any | null, recordingRetention?: number | null, recordingLocation?: string | null, mohSoundDownloadToken?: string | null, parkSoundDownloadToken?: string | null, presenceInDomainPreauthorized: boolean, images: Array<{ __typename?: 'DomainImage', id: number, type: string, hash?: string | null }>, mohSound?: { __typename?: 'Media', id: number, description?: string | null } | null, parkSound?: { __typename?: 'Media', id: number, description?: string | null } | null } | null> } | null, domainTheme?: { __typename?: 'DomainTheme', background?: string | null, logo?: string | null, login?: string | null } | null };


export const DomainSettingsDocument = gql`
    query DomainSettings($domainId: Int!) {
  domains(id: $domainId) {
    items {
      id
      name
      description
      companyName
      preferDisplayNamesForStationNames
      shortNumbersLength
      specialNumbersDialoutPrefix
      smtpAuthEnabled
      smtpUsername
      smtpUserpass
      pinBasedCalls
      privateRoutingType
      dialoutPrefix
      attendantPrefix
      requirePinForStartingPrivateCalls
      groupDomain
      faxSignature
      baseColor
      loginBackgroundColor
      backgroundIsCenter
      backgroundColor
      outgoingCallBarringOperator
      outgoingCallBarringAdmin
      recordingRetention
      recordingLocation
      images {
        id
        type
        hash
      }
      mohSound {
        id
        description
      }
      mohSoundDownloadToken
      parkSound {
        id
        description
      }
      parkSoundDownloadToken
      presenceInDomainPreauthorized
    }
  }
  domainTheme(domainId: $domainId) {
    background
    logo
    login
  }
}
    `;

/**
 * __useDomainSettingsQuery__
 *
 * To run a query within a React component, call `useDomainSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainSettingsQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainSettingsQuery(baseOptions: Apollo.QueryHookOptions<DomainSettingsQuery, DomainSettingsQueryVariables> & ({ variables: DomainSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainSettingsQuery, DomainSettingsQueryVariables>(DomainSettingsDocument, options);
      }
export function useDomainSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainSettingsQuery, DomainSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainSettingsQuery, DomainSettingsQueryVariables>(DomainSettingsDocument, options);
        }
export function useDomainSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainSettingsQuery, DomainSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainSettingsQuery, DomainSettingsQueryVariables>(DomainSettingsDocument, options);
        }
export type DomainSettingsQueryHookResult = ReturnType<typeof useDomainSettingsQuery>;
export type DomainSettingsLazyQueryHookResult = ReturnType<typeof useDomainSettingsLazyQuery>;
export type DomainSettingsSuspenseQueryHookResult = ReturnType<typeof useDomainSettingsSuspenseQuery>;
export type DomainSettingsQueryResult = Apollo.QueryResult<DomainSettingsQuery, DomainSettingsQueryVariables>;